// extracted by mini-css-extract-plugin
module.exports = {"share":"ShareButton_share__IcY55","share_message":"ShareButton_share_message__1wK6n"};